import { Text, type TypographyVariant } from '@shared/ui/antd';
import { ConditionalWrapper } from '@shared/ui/conditional-wrapper';
import { Tooltip } from 'antd';
import type { FC, ThHTMLAttributes } from 'react';

const MAX_TEXT_LENGTH = 20;
const DEFAULT_LINE_CLAMP = 2;

export type THeadCellTooltipProps = ThHTMLAttributes<HTMLTableCellElement> & {
  text?: string | null;
  maxLength?: number;
  lineClamp?: number;
  width?: number;
  variant?: TypographyVariant;
  fontWeight?: React.CSSProperties['fontWeight'];
};

export const THeadCellTooltip: FC<THeadCellTooltipProps> = ({
  text,
  variant = 'sm',
  fontWeight = 700,
  maxLength = MAX_TEXT_LENGTH,
  lineClamp = DEFAULT_LINE_CLAMP,
  width,
  ...props
}) => {
  const hasLongText = !!text && text.length > maxLength;
  const clampedText = hasLongText ? `${text!.slice(0, maxLength)}...` : text;

  return (
    <th style={{ width }} {...props}>
      <ConditionalWrapper
        condition={hasLongText}
        wrapper={(children) => (
          <Tooltip title={text} placement="top" style={{ textAlign: 'left', maxWidth: '400px' }}>
            {children}
          </Tooltip>
        )}
      >
        <Text variant={variant} fontWeight={fontWeight}>
          {clampedText}
        </Text>
      </ConditionalWrapper>
    </th>
  );
};
